import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { OnboardingDetailsDto } from '@/api/generated';

type Return = {
  getOnboardingDetails: (userId: string) => Promise<OnboardingDetailsDto>;
  isGettingOnboardingDetails: boolean;
};

export const useGetUserOnboardingDetails = (): Return => {
  const { onboardingApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<OnboardingDetailsDto, AxiosError, string>({
    meta: { disableSuccessAlert: true },
    mutationFn: async userId => {
      const res = await onboardingApi.getOnboardingDetails(userId);
      return res.data;
    },
  });

  return {
    getOnboardingDetails: mutateAsync,
    isGettingOnboardingDetails: isPending,
  };
};
